import { useState } from "react";
import FloatingButton from "./FloatingButton";
import MultipleItemCreate from "../../components/AssetManagement/Overview/ActionItems/ActionItemsTableActions/MultipleItemCreate/MultipleItemCreate";

type PropsFloating = {
  selectedSiteFloatingAction: string;
  selectedDimensionsFloatingAction: string;
  trackIdFloatingAction: string;
  disabledButton?: boolean;
};

export default function FloatingActionItems({
  selectedSiteFloatingAction,
  selectedDimensionsFloatingAction,
  trackIdFloatingAction,
  disabledButton = false,
}: PropsFloating) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <FloatingButton
        disabledButton={disabledButton}
        handleClick={() => setOpen(true)}
      />
      {open &&
      (selectedSiteFloatingAction || selectedDimensionsFloatingAction) ? (
        <MultipleItemCreate
          open={open}
          handleClose={() => setOpen(false)}
          selectedSiteFloatingAction={selectedSiteFloatingAction}
          selectedDimensionsFloatingAction={selectedDimensionsFloatingAction}
          trackIdFloatingAction={trackIdFloatingAction}
        />
      ) : (
        ""
      )}
    </>
  );
}
